import { createFilter, deleteFilter, getFilters, updateFilter } from '@/api/legacy/filters';
import { Logger } from '@/helpers/log';
import { naturalSort } from '@/helpers/util';
import StoreCache from '@/store/cache';
import { CREATE_FILTER, DELETE_FILTER, FETCH_FILTERS, UPDATE_FILTER } from '@/store/types/actions';
import { FILTERS_FETCHED, FILTER_CREATED, FILTER_DELETED, FILTER_UPDATED } from '@/store/types/mutations';

const cache = new StoreCache();

const logger = new Logger('store:amplify:filters');

const getters = {};

const actions = {
  [FETCH_FILTERS]({ commit, state }) {
    if (cache.isReady()) {
      return Promise.resolve(state.filters);
    } if (cache.isPending()) {
      return cache.getPendingPromise();
    }

    return cache.setPendingPromise(getFilters().then((filters) => {
      commit(FILTERS_FETCHED, filters);
    }));
  },
  [CREATE_FILTER]({ commit }, data) {
    return createFilter(data).then((filter) => {
      commit(FILTER_CREATED, filter);
      return filter; // FIXME: do not rely on responses.
    });
  },
  [UPDATE_FILTER]({ commit }, filterData) {
    return updateFilter(filterData)
      .then((filter) => commit(FILTER_UPDATED, filter));
  },
  [DELETE_FILTER]({ commit }, filter) {
    if (!filter || typeof filter !== 'object') {
      return Promise.reject(new Error('A filter object must be passed in to delete'));
    }
    return deleteFilter(filter)
      .then(() => commit(FILTER_DELETED, filter));
  },
};

const mutations = {
  [FILTERS_FETCHED](state, filters) {
    state.filtersFetched = true;
    state.filters = naturalSort(filters, 'name');
  },
  [FILTER_CREATED](state, newFilter) {
    const filterArray = state.filters.concat([newFilter]);
    state.filters = naturalSort(filterArray, 'name');
  },
  [FILTER_UPDATED](state, updatedFilter) {
    state.filter = updatedFilter;

    // Map the filter in and re-sort
    state.filters = naturalSort(state.filters.map((f) => {
      if (f.id === updatedFilter.id) {
        return updatedFilter;
      }
      return f;
    }), 'name');
  },
  [FILTER_DELETED](state, filter) {
    const index = state.filters.findIndex(({ id }) => id === filter.id);
    if (index < 0) {
      logger.error('Unknown filter deleted', filter);
      return;
    }
    state.filters.splice(index, 1);
  },
};

const state = {
  filters: [],
  filtersFetched: false, // This keeps track of whether we have already fetched filters
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
